function getPowerReviewsCredentials() {
  
  const api_key = '4e42b676-7ec1-440c-a825-a895dc6e52a3',
    	locale = 'en_US',
    	merchant_group_id = '33554686',
    	merchant_id = '932040371';
  
  window.loadPowerReviews(api_key,locale,merchant_group_id,merchant_id);
}